
// @ts-nocheck


export const localeCodes =  [
  "ar",
  "en",
  "fr",
  "es",
  "ru",
  "zh"
]

export const localeLoaders = {
  "ar": [],
  "en": [],
  "fr": [],
  "es": [],
  "ru": [],
  "zh": []
}

export const vueI18nConfigs = [
  () => import("../config/i18n.config.ts?hash=dcfe1420&config=1" /* webpackChunkName: "i18n_config_dcfe1420" */),
  () => import("../config/i18n.config.ts?hash=dcfe1420&config=1" /* webpackChunkName: "__config_i18n_config_ts_dcfe1420" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./config/i18n.config.ts",
  "locales": [
    {
      "code": "ar",
      "dir": "rtl",
      "language": "ar-SA"
    },
    {
      "code": "en",
      "language": "en-US"
    },
    {
      "code": "fr",
      "language": "fr-FR"
    },
    {
      "code": "es",
      "language": "es-ES"
    },
    {
      "code": "ru",
      "language": "ru-RU"
    },
    {
      "code": "zh",
      "language": "zh-CN"
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "en",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ar",
    "dir": "rtl",
    "language": "ar-SA",
    "files": []
  },
  {
    "code": "en",
    "language": "en-US",
    "files": []
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "files": []
  },
  {
    "code": "es",
    "language": "es-ES",
    "files": []
  },
  {
    "code": "ru",
    "language": "ru-RU",
    "files": []
  },
  {
    "code": "zh",
    "language": "zh-CN",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
